/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Agent } from './agent';
import { Policyholder } from './policyholder';
import { InsuredObject } from './insuredObject';
import { SalesProduct } from './salesProduct';
import { Partner } from './partner';
import { PreviousContract } from './previousContract';
import { InsuranceReason } from './insuranceReason';
import { Marketing } from './marketing';

/**
 * Bipro TAA process.   Contains all properties common to quote, getQuote and order.   (german: TAA Geschäftsvorgang)   (bipro-versicherung-tarifierung::TAA)
 */
export interface TAA {
  /**
   * This affects the price calculation and various other configuration data. Format as defined by RFC 3339, section 5.6, for example, 2025-01-21T17:32:28+02:00. This time must be equal for quote and order within a business transaction.   (german: Tarifierungszeitpunkt)   (VMP: ratingDate)
   */
  quoteTime: string;
  /**
   * Unique transaction number of Verti. This number may be returned to the API consumer in API responses. In subsequent API requests, belonging to the same business transaction, this number must be provided in the request.   (bipro-gevo::Vorgangsnummer)
   */
  transactionNumber?: string;
  /**
   * Unique transaction number of the API consumer. For informational purposes only.   (bipro-gevo::VorgangsnummerVM)
   */
  transactionNumberExternal?: string;
  applicationNumberExternal?: string;
  agent: Agent;
  insuranceReason?: InsuranceReason;
  marketing?: Marketing;
  /**
   * List of all relevant partners. Every partner object in this list is referenced by one or more partner roles.
   */
  partners: Array<Partner>;
  policyholder: Policyholder;
  /**
   * List of all relevant insured objects. This may be a motor vehicle for motor insurance, a dog for dog owner insurance, etc. Every insured object in this list is referenced by one or more insured object roles.   (german: Gegenstand)
   */
  insuredObjects?: Array<InsuredObject>;
  salesProduct: SalesProduct;
  /**
   * List of previous insurances.   (german: Vorversicherung)
   */
  previousInsurances?: Array<PreviousContract>;
}
export namespace TAA {}
